// Copyright (c) StrangeBee 2023

import { ColumnTitle } from '@Atoms/ColumnTitle/ColumnTitle';
import { ColumnType } from 'antd/lib/table';
import React from 'react';
import { TableField } from './type';

export function computeHeader<T>({ title, ...rest }: ColumnType<T>): ColumnType<T> {
    const titleParsed = Array.isArray(title) ? <ColumnTitle>{(title.find(Boolean) as any)?.label} </ColumnTitle> : null;

    return {
        title: React.isValidElement(title) || typeof title === 'string' ? title : titleParsed,
        ...rest,
    };
}

export type ColumnsRendererType<T> = (
    fields: TableField<T>[],
    treatDataList?: (d: TableField<T>) => ColumnType<T>,
) => ColumnType<T>[];

export function columnsRenderer<T>(
    fields: TableField<T>[],
    treatDataList = (d: TableField<T>): ColumnType<T> => d as ColumnType<T>,
): ColumnType<T>[] {
    return fields.reduce((acc, field) => {
        if (field.hidden) {
            return acc;
        }
        const opt = field.children ? { children: columnsRenderer(field.children, treatDataList) } : {};

        return [...acc, computeHeader(treatDataList({ ...field, ...opt } as TableField<T>))];
    }, [] as ColumnType<T>[]);
}
